module.exports = __webpack_public_path__ + "static/media/national-map.9043a621.svg";